import { DataInput } from '@/components/DataInput/DataInput'
import { DataTag } from '@/components/DataTag/DataTag'
import { SectionCard } from '@/components/SectionCard/SectionCard'
import { Tag, Text } from '@chakra-ui/react'

type HivesOverviewClusterCardProps = {
  //biome-ignore lint/suspicious/noExplicitAny:
  cluster: any
  index?: number
}

export function HivesOverviewClusterCard({
  cluster,
  index,
}: Readonly<HivesOverviewClusterCardProps>) {
  return (
    <SectionCard
      mt={4}
      key={`${cluster.hive_info.cluster_id}-${index}`}
      title={
        index !== null && index !== undefined
          ? `Cluster #${index + 1}`
          : 'Cluster'
      }
    >
      <DataInput mt={2} label="Cluster ID" value={cluster.hive_info.cluster_id}>
        {cluster.hive_info.cluster_id}
      </DataInput>
      <DataInput mt={2} label="Stripe ID" value={cluster.stripe_id}>
        {cluster.stripe_id}
      </DataInput>
      <DataInput mt={2} label="User ID" value={cluster.user_info?.user_id}>
        {cluster.user_info?.user_id}
      </DataInput>
      {/*  @RobinAtherton - TODO this is a backend typing error but lets just ignore it for now, */}
      {/*  this should be of type ModifiedHiveInfo but it is of Type HiveInfo*/}
      <DataInput mt={2} label="Plan" value={cluster.hive_info.plan}>
        {cluster.hive_info.plan}
      </DataInput>
      {/*  TODO need to replace this with some icon in the top of the sectioncard somewhere*/}
      <DataInput mt={2} label="Status" value={cluster.hive_info.hive_status}>
        {cluster.hive_info.hive_status}
      </DataInput>
      <DataInput mt={2} label="Apiary" value={cluster.hive_info.apiary}>
        {cluster.hive_info.apiary}
      </DataInput>
      <DataInput
        mt={2}
        label="Authentication Method"
        value={cluster.hive_info.authentication_method}
      >
        {cluster.hive_info.authentication_method}
      </DataInput>
      <Text mt={2} fontWeight={500} fontSize={16}>
        Broker Features
      </Text>
      {cluster.hive_info.broker_features.length > 0 &&
        cluster.hive_info.broker_features?.map((feature: string) => (
          <DataTag key={feature} value={feature}>
            {feature}
          </DataTag>
        ))}
      {cluster.hive_info.broker_features.length === 0 && (
        <Tag.Root mt={2} backgroundColor="red.200">
          <Tag.Label>N / A</Tag.Label>
        </Tag.Root>
      )}
    </SectionCard>
  )
}
